export const settings = {
  isDemo: true
}